import HeaderLogo from '@/assets/logo_twm.png'
import { getImageSize, pixelToDxa } from '@/libs/utils/docxUtils'
import { AlignmentType, ImageRun, Paragraph, TextRun } from 'docx'
import TaiwanDate from '../../../ReportPDF/TaiwanDateConvert'

const CoverPage = async ({ reportData }) => {
  const { reprotDao, phishType } = reportData || {}
  const { companyName, campaignStartDate } = reprotDao || {}
  const service = phishType

  const { width, height } = await getImageSize({ image: HeaderLogo, width: 502 })
  const imgData = await fetch(HeaderLogo)

  return [
    new Paragraph({
      alignment: AlignmentType.CENTER,
      spacing: { before: pixelToDxa(150), after: pixelToDxa(200) },
      children: [
        new ImageRun({
          data: await imgData.blob(),
          transformation: {
            width,
            height,
          },
        }),
      ],
    }),
    new Paragraph({
      alignment: AlignmentType.CENTER,
      children: [
        new TextRun({
          text: '社交工程',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 72,
        }),
        new TextRun({
          text: service,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 72,
        }),
        new TextRun({
          text: '演練服務',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 72,
        }),
        new TextRun({
          text: '演練結果報告書',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 72,
          break: 1,
        }),
      ],
      border: { bottom: { color: '#3366FF', space: 20, style: 'single', size: 1 } },
    }),
    new Paragraph({
      alignment: AlignmentType.CENTER,
      // spacing: { before: pixelToDxa(50), after: pixelToDxa(50) },
      spacing: {
        before: pixelToDxa(10), // 藍線與公司名稱距離 ↑↑ 加大
        after: pixelToDxa(0), // 公司名稱與日期距離 ↓↓ 縮小
        line: pixelToDxa(30), // 公司名稱行距適中，不要撐太大
      },
      children: [
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 56,
        }),
      ],
    }),
    new Paragraph({
      alignment: AlignmentType.CENTER,
      // spacing: { line: pixelToDxa(20) },
      spacing: {
        before: pixelToDxa(0), // 日期前的空間縮小
        line: pixelToDxa(20),
      },
      children: [
        new TextRun({
          text: TaiwanDate({ reportDate: campaignStartDate }),
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 36,
          bold: true,
        }),
      ],
    }),
  ]
}

export default CoverPage
